// This file is used for maintain and manage API services.
(function() {
  'use strict';
  angular.module('obex').
  factory('organizations', ['$http', 'obexConstant', 'authService',
    function($http, obexConstant, authService) {
      let showAll = false;
      return {
        setShowAll(showAllClients) {
          showAll = showAllClients;
        },
        getShowAll() {
          return showAll;
        },
        addOrganization(organization) {
          return authService.getAuthorizationHeader().then(authHeader => {
            const postData = {
              Id: organization.Id,
              Name: organization.Name,
              AddressLine1: organization.AddressLine1,
              AddressLine2: organization.AddressLine2,
              City: organization.City,
              PostalCode: organization.PostalCode,
              Country: organization.Country,
              StateProv: organization.StateProv,
              IsTravelAgency: organization.IsTravelAgency,
              TravelAgencyId: organization.TravelAgencyId,
              AllowOpenBookings: organization.AllowOpenBookings,
              AllowFbChat: organization.AllowFbChat,
              BookingToolName: organization.BookingToolName,
              Domains: organization.Domains,
              TripLinkAccounts: organization.TripLinkAccounts,
              AcceptEmails: organization.AcceptEmails,
              WebSite: organization.WebSite,
              LogoImageLink: organization.LogoImageLink,
            };
            return $http.post(obexConstant.urlOrganization, postData, {
              headers: authHeader,
            });
          });
        },
        getOrganizations() {
          return authService.getAuthorizationHeader().then(authHeader => {
            return $http.get(obexConstant.urlOrganization, {
              headers: authHeader,
            });
          });
        },
        getOrganizationById(id) {
          return authService.getAuthorizationHeader().then(authHeader => {
            const url = `${obexConstant.urlOrganization}/${id}`;
            return $http.get(url, {
              headers: authHeader,
            });
          });
        },
        getClients(includeAllClients = false) {
          const url = obexConstant.urlClients+ '/' + (includeAllClients === true ? 'true' : 'false')
          return authService.getAuthorizationHeader().then(authHeader => {
            return $http.get(url, {
              headers: authHeader,
            });
          });
        },
        getAgencies(includeAllAgencies = false) {
          const url = includeAllAgencies === true ? obexConstant.urlAgencies+'/'+includeAllAgencies : obexConstant.urlAgencies;
          return authService.getAuthorizationHeader().then(authHeader => {
            return $http.get(url, {
              headers: authHeader,
            });
          });
        },
        getSelectedAgencyClients(travelAgency,includeAllClients = false) {
          const url = `${obexConstant.urlAgenciesClients}/${travelAgency}/`;
          return authService.getAuthorizationHeader().then(authHeader => {
            return $http.get(url, {
              headers: authHeader,
            });
          });
        },
        updateOrganization(id, organization) {
          return authService.getAuthorizationHeader().then(authHeader => {
            const url = `${obexConstant.urlOrganization}/${id}`;
            const putData = {
              Id: organization.Id,
              Name: organization.Name,
              AddressLine1: organization.AddressLine1,
              AddressLine2: organization.AddressLine2,
              City: organization.City,
              PostalCode: organization.PostalCode,
              Country: organization.Country,
              StateProv: organization.StateProv,
              IsTravelAgency: organization.IsTravelAgency,
			        Inactive: organization.Inactive,
              TravelAgencyId: organization.TravelAgencyId,
              AllowOpenBookings: organization.AllowOpenBookings,
              AllowFbChat: organization.AllowFbChat,
              BookingToolName: organization.BookingToolName,
              Domains: organization.Domains,
              TripLinkAccounts: organization.TripLinkAccounts,
              AcceptEmails: organization.AcceptEmails,
              WebSite: organization.WebSite,
              LogoImageLink: organization.LogoImageLink,
              TravelAgencyPhone: organization.TravelAgencyPhone
            };
            if (organization.TravelAgencyAfterHoursPhone !== null) {
              putData["TravelAgencyAfterHoursPhone"] = organization.TravelAgencyAfterHoursPhone;
            }
            if (organization.TravelAgencyInternationalPhone !== null) {
              putData["TravelAgencyInternationalPhone"] = organization.TravelAgencyInternationalPhone;
            }
            if (organization.TravelAgencyEmail !== null) {
              putData["TravelAgencyEmail"] = organization.TravelAgencyEmail;
            }
            if (organization.TravelAgencyStartRegularHours !== null) {
              putData["TravelAgencyStartRegularHours"] = organization.TravelAgencyStartRegularHours;
            }
            if (organization.TravelAgencyEndRegularHours !== null) {
              putData["TravelAgencyEndRegularHours"] = organization.TravelAgencyEndRegularHours;
            }
            if (organization.TravelAgencyWindowsTimeZoneId !== null) {
              putData["TravelAgencyWindowsTimeZoneId"] = organization.TravelAgencyWindowsTimeZoneId;
            }
            if (organization.TravelAgencyServiceStartDay !== null) {
              putData["TravelAgencyServiceStartDay"] = organization.TravelAgencyServiceStartDay;
            }
            if (organization.TravelAgencyServiceEndDay !== null) {
              putData["TravelAgencyServiceEndDay"] = organization.TravelAgencyServiceEndDay;
            }
            return $http.put(url, putData, {
              headers: authHeader,
            });
          });
        },
        deleteOrganization(id) {
          return authService.getAuthorizationHeader().then(authHeader => {
            const url = `${obexConstant.urlOrganization}/${id}`;
            return $http.delete(url, {
              headers: authHeader,
            });
          });
        },
        getCountries() {
          return $http.get('/js/content/countryData.json');
        },
        getStates() {
          return $http.get('/js/content/stateData.json');
        },
      };
    },
  ]);
})();


// WEBPACK FOOTER //
// ./client/js/services/organizations.service.js